<div class="pt-vote-results__header">
  <div class="pt-vote-results__header-info">
    <span class="pt-vote-results__header-regular">
      <pu-icon
        class="pt-vote-results__header-info-icon"
        iconName="community"
        size="20"
      />

      {{ 'voteResults.participants' | translate: { participants: results().answersCount } }}
    </span>

    <span class="pt-vote-results__header-regular" data-html2canvas-ignore>
      <pu-icon
        class="pt-vote-results__header-info-highlight"
        iconName="clock"
        size="20"
      />

      @if (timeLeft()) {
        <span class="pt-vote-results__header-info-highlight">
          {{ timeLeft() }}
        </span>
        {{ 'userVote.finished.timeUntilEnd' | translate }}
      } @else {
        <span class="pt-vote-results__header-info-danger">
          {{ 'userVote.finished.timeEnded' | translate }}
        </span>
      }
    </span>
  </div>
</div>

<div class="pt-vote-results__question">
  <div
    [class]="gridClasses()"
  >
    @for (option of sortedOptions(); track option.id) {
      <div class="pt-vote-results__option">
        <div class="pt-vote-results__option-inner">
          @if (displaySelected()) {
            @if (isCheckbox()) {
              <div
                class="pt-vote-results__option-checkbox"
                [class.pt-vote-results__option-checkbox-selected]="option.isSelected"
              >
                @if (option.isSelected) {
                  <pu-icon
                    iconName="pu-checkbox-yes"
                    size="16"
                  />
                }
              </div>
            } @else {
              <div
                class="pt-vote-results__option-radio"
                [class.pt-vote-results__option-radio-selected]="option.isSelected"
              ></div>
            }
          }

          @if (isWithImage() && option.image) {
            <div class="pt-vote-results__option-image">
              <img
                [src]="option.image.url"
                [alt]="option.choiceText"
              />
            </div>
          }

          <div class="pt-vote-results__option-info">
            <div class="pt-vote-results__option-info-header">
              @if (medalPositions().gold.includes($index)) {
                <pu-icon
                  iconName="crown"
                  size="20"
                  class="pt-vote-results__option-crown-gold"
                />
              } @else if (medalPositions().silver.includes($index)) {
                <pu-icon
                  iconName="crown"
                  size="20"
                  class="pt-vote-results__option-crown-silver"
                />
              } @else if (medalPositions().bronze.includes($index)) {
                <pu-icon
                  iconName="crown"
                  size="20"
                  class="pt-vote-results__option-crown-bronze"
                />
              }
              <span class="pt-vote-results__option-title">
                {{ option.choiceText }}
              </span>
            </div>

            <div class="pt-vote-results__option-bar-wrapper">
              <div
                class="pt-vote-results__option-bar"
                [style.width.%]="option.percentage"
              ></div>
            </div>

            <span class="pt-vote-results__option-count">{{ 'voteResults.voted' | translate: { count: option.answersCount } }}</span>
          </div>

          <div class="pt-vote-results__option-stats">
            <span
              class="pt-vote-results__option-percent"
              [class.pt-vote-results__option-percent_gold]="medalPositions().gold.includes($index)"
              [class.pt-vote-results__option-percent_silver]="medalPositions().silver.includes($index)"
              [class.pt-vote-results__option-percent_bronze]="medalPositions().bronze.includes($index)"
            >{{ option.percentage }}%</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>